import type { PageType } from './enums';

interface DefaultGTMParams {
  locale: string;
  city: string;
  pageType: string;
}

export class GTMParamsManager {
  private static instance: GTMParamsManager;
  private params: Partial<Record<PageType, Record<string, string | boolean | number>>> = {};
  private defaultParams: DefaultGTMParams | null = null;

  private constructor() {}

  public static getInstance(): GTMParamsManager {
    if (!GTMParamsManager.instance) {
      GTMParamsManager.instance = new GTMParamsManager();
    }
    return GTMParamsManager.instance;
  }

  public setDefaultParams(params: DefaultGTMParams) {
    this.defaultParams = params;
  }

  public getParams(page: PageType) {
    return {
      ...(this.defaultParams || {}),
      ...(this.params[page] || {}),
    };
  }

  public addParams(page: PageType, params: Record<string, string | boolean | number>) {
    if (Object.keys(params).length > 0) {
      this.params[page] = params;
    }
  }

  public patchParams(page: PageType, newParams: Record<string, string | boolean | number>) {
    if (!this.params[page]) {
      this.params[page] = {};
    }
    this.params[page] = {
      ...this.params[page],
      ...newParams,
    };
  }

  public delParams(page: PageType) {
    delete this.params[page];
  }
}
